import React, { useRef, useState } from 'react';

// TODO: Replace with your actual Cloudinary cloud name
const CLOUD_NAME = 'dpwuxopjb';
const UPLOAD_PRESET = '2nice-preset';
const FOLDER = '2nice_folder';

export default function ImageUpload({ onUpload, label = 'Upload Image', initialUrl }) {
  const [imageUrl, setImageUrl] = useState(initialUrl || '');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    setError('');
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', UPLOAD_PRESET);
      formData.append('folder', FOLDER);

      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data.secure_url) {
        setImageUrl(data.secure_url);
        if (onUpload) onUpload(data.secure_url);
      } else {
        setError('Upload failed.');
      }
    } catch (err) {
      setError('Upload failed.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', marginBottom: 8 }}>{label}</label>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        disabled={uploading}
      />
      {uploading && <div style={{ color: '#3498db', marginTop: 8 }}>Uploading...</div>}
      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
      {imageUrl && (
        <div style={{ marginTop: 12 }}>
          <img src={imageUrl} alt="Uploaded" style={{ maxWidth: 180, borderRadius: 8 }} />
        </div>
      )}
    </div>
  );
} 